<div class="inner-content">
  <ion-toolbar color="warning">
    <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">{{ 'shared.session_expiry.title' | transloco }}</ion-title>
  </ion-toolbar>

  <div class="ion-padding ion-text-center">
    <ion-icon name="time-outline" class="expiry-icon"></ion-icon>

    <p class="countdown fs-pt-24" role="timer" aria-live="polite" aria-atomic="true">{{ displayTime }}</p>

    <p class="fs-pt-14">{{ 'shared.session_expiry.message' | transloco }}</p>
  </div>

  <ion-grid>
    <ion-row class="ion-justify-content-center ion-align-items-center">
      <ion-col size-sm="12" size-xl="6" size-md="8">
        <ion-button class="ion-margin-top ion-text-uppercase"
          color="primary"
          [disabled]="loading"
          (click)="extend()"
          fill="solid"
          expand="block">
          @if (loading) {
            <ion-spinner name="crescent" class="ion-margin-end"></ion-spinner>
          }
          {{ (loading ? 'shared.session_expiry.attendere' : 'shared.session_expiry.estendi') | transloco }}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</div>
